"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    mainnet: "https://axelar-mainnet.s3.us-east-2.amazonaws.com/mainnet-config.json",
    testnet: "https://axelar-testnet.s3.us-east-2.amazonaws.com/testnet-config.json",
    devnet: "https://axelar-testnet.s3.us-east-2.amazonaws.com/testnet-config.json", //same as testnet for now
};
//# sourceMappingURL=s3.js.map